import { Link } from "react-router-dom";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer data-testid="site-footer" className="relative mt-20 border-t border-white/10">
      <div className="uj-bar" />
      <div className="max-w-[1440px] mx-auto px-6 md:px-10 py-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-6">
            <div className="eyebrow mb-4">/ BROKEN RP · UK ROLEPLAY</div>
            <h4 className="font-display text-white text-6xl md:text-8xl leading-[0.85] tracking-tighter">
              THE<br />ENDS<span className="text-[color:var(--accent-red)]">.</span>
            </h4>
            <p className="text-zinc-400 mt-6 max-w-sm text-sm leading-relaxed">
              www.brokenrp.co.uk — official webstore. Delivered in-game by staff via Discord notification.
            </p>
          </div>

          <div className="md:col-span-3">
            <div className="eyebrow mb-4">Store</div>
            <ul className="space-y-2 font-mono text-[12px] text-zinc-300">
              <li><Link to="/shop?category=starter-packs" className="hover:text-white">Starter Packs</Link></li>
              <li><Link to="/shop?category=weapon-packs" className="hover:text-white">Weapon Packs</Link></li>
              <li><Link to="/shop?category=gang-packs" className="hover:text-white">Gang Packs</Link></li>
              <li><Link to="/shop?category=one-of-one" className="hover:text-white">1 of 1 Cars</Link></li>
              <li><Link to="/shop?category=starter-free" className="hover:text-white">Free Starter Car</Link></li>
              <li><Link to="/shop?category=car-drop" className="hover:text-white">Car Drops</Link></li>
              <li><Link to="/shop?category=mlos" className="hover:text-white">MLO's</Link></li>
              <li><Link to="/shop?category=businesses" className="hover:text-white">Businesses</Link></li>
            </ul>
          </div>

          <div className="md:col-span-3">
            <div className="eyebrow mb-4">Community</div>
            <ul className="space-y-2 font-mono text-[12px] text-zinc-300">
              <li>
                <a data-testid="footer-discord" href="https://discord.gg/brokenrp" target="_blank" rel="noreferrer" className="hover:text-white">
                  Discord →
                </a>
              </li>
              <li>
                <a data-testid="footer-kofi" href="https://ko-fi.com/brokenrp" target="_blank" rel="noreferrer" className="hover:text-white">
                  Ko-fi →
                </a>
              </li>
              <li><Link to="/account" className="hover:text-white">My Account →</Link></li>
              <li><Link to="/admin/login" className="hover:text-white">Staff Login →</Link></li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-6 border-t border-white/10 flex flex-col md:flex-row items-start md:items-center justify-between gap-3 font-mono text-[10px] tracking-[0.24em] uppercase text-zinc-500">
          <div>© {year} BROKEN RP · UK ROLEPLAY. NO JUSTICE NO PEACE.</div>
          <div>EVERY STORY STARTS BROKEN</div>
        </div>
      </div>
    </footer>
  );
}
